var render = function () {
  var _vm$pdm, _vm$pdm2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "buy-panel-product-image"
  }, [_c('base-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSpinner,
      expression: "showSpinner"
    }],
    class: {
      'position-higher': _vm.isSpinnerPositionHigher
    }
  }), _c('div', {
    staticClass: "buy-panel-product-image--container"
  }, [_vm.isApparel && _vm.imageSrc && !this.showSpinner ? _c('span', [_vm._v("FRONT")]) : _vm._e(), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !this.showSpinner,
      expression: "!this.showSpinner"
    }],
    class: ['buy-panel-product-image-model-image', {
      'buy-panel-product-image-model-image--apparel': _vm.isApparel
    }],
    attrs: {
      "src": _vm.imageSrc,
      "alt": (_vm$pdm = _vm.pdm) === null || _vm$pdm === void 0 ? void 0 : _vm$pdm.product_name
    },
    on: {
      "load": function load($event) {
        return _vm.hideSpinner(true);
      }
    }
  })]), _vm.isApparel && _vm.imageSrcAdditional ? _c('div', {
    staticClass: "buy-panel-product-image--container"
  }, [!this.showSpinner ? _c('span', [_vm._v("BACK")]) : _vm._e(), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !this.showSpinner,
      expression: "!this.showSpinner"
    }],
    class: ['buy-panel-product-image-model-image', {
      'buy-panel-product-image-model-image--apparel': _vm.isApparel
    }],
    attrs: {
      "src": _vm.imageSrcAdditional,
      "alt": (_vm$pdm2 = _vm.pdm) === null || _vm$pdm2 === void 0 ? void 0 : _vm$pdm2.product_name
    },
    on: {
      "load": function load($event) {
        return _vm.hideSpinner(true);
      }
    }
  })]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }